import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "@/router";
import { I18nextProvider } from "react-i18next";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { useTokenRefresh } from "@/hooks/useTokenRefresh";
import i18n from "@/i18n";

// create a client defaults
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - data is fresh for 5 minutes
      gcTime: 10 * 60 * 1000, // unused cache is removed after 10 minutes
      retry: 1, // Retry failed requests once
      refetchOnWindowFocus: false,
      refetchOnReconnect: true, // refetch when network reconnects
    },
  },
});

function AppContent() {
  // Automatically refresh token before expiration
  useTokenRefresh();

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AppContent />
        {/* show React Query DevTools in development only */}
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
